export const GOOGLE_PLATFORM_SRC = 'https://apis.google.com/js/platform.js';

export interface GoogleReviewOrder {
  orderID?: unknown;
  customerEmail?: unknown;
  shippingCountry?: unknown;
  estDeliveryDate?: unknown;
}

export function getGoogleReviewParams(order: GoogleReviewOrder) {
  const orderId = String(order.orderID ?? '').trim();
  const email = String(order.customerEmail ?? '').trim();
  const country = String(order.shippingCountry ?? '').trim().toUpperCase();
  const deliveryDate = String(order.estDeliveryDate ?? '').trim();
  const date = new Date(`${deliveryDate}T00:00:00Z`);

  if (!orderId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    || !/^[A-Z]{2}$/.test(country) || country === 'ZZ'
    || !/^\d{4}-\d{2}-\d{2}$/.test(deliveryDate)
    || !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== deliveryDate) {
    return null;
  }

  return {
    merchant_id: 7552790,
    order_id: orderId,
    email,
    delivery_country: country,
    estimated_delivery_date: deliveryDate,
    opt_in_style: 'CENTER_DIALOG' as const,
  };
}

declare global {
  interface Window { // eslint-disable-line no-unused-vars
    gapi?: {
      load: (_module: string, _callback: () => void) => void;
      surveyoptin: { render: (_params: NonNullable<ReturnType<typeof getGoogleReviewParams>>) => void };
      ratingbadge: { render: (_container: HTMLElement, _params: { merchant_id: string; position: string }) => void };
    };
  }
}
